









































/** デコレータ利用のためComponent, Vueをimport **/
import { Component, Vue } from 'vue-property-decorator';
/** 画面で必要なVuexの各stateをimport **/
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';

/** 画面で利用するバックエンド設定のimport **/
import {
  FieldChildrenProp,
  GetInputFieldsActons
} from '@/services/hexabase/types';
import { informationRules } from '@/constants/form/inputCheck';
import { informationRegisterOptionalForm } from '@/constants/form/informationForm';
import { 
  InformationDetailDefine,
  authorityInvalidMessage,
  authorityValidMessage,
  registerDialogTitle,
  registerFinishText,
  registerFinishAction
} from '@/constants/information/information';

/** 画面で利用するモデルファイルをimport **/
import InformationModel from '@/models/informationModel';
/** 画面で利用するコンポーネントをimport 下部に存在する＠Componentにも記載する **/
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import InformationBasicInfoPanel from '@/components/information/detail/InformationBasicInfoPanel.vue';
/** 画面で利用する共通ライブラリをimport **/

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    TransitionDialog,
    ExecAction,
    InformationBasicInfoPanel
  }
})

/* eslint-disable @typescript-eslint/camelcase */
export default class InformationRegister extends Vue {
  // モデルをセット
  readonly basicModel = new InformationModel();
  // アプリケーションID
  private applicationId = hexabaseState.applicationId;
  // お知らせ情報マスタのデータストアのID
  private mainDsId = hexabaseState.datastoreIds['お知らせ情報マスタ'];

  // お知らせ情報のデータ
  basicFieldData: Array<FieldChildrenProp> = [];
  // お知らせ情報のカラムデータ
  basicFieldCols = '';

  // 登録用情報格納プロパティ
  registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };

  // アイテム登録後ダイアログ
  dialogTitle = registerDialogTitle;
  dialogStatus = false;
  isLoading = false;
  registerText = registerFinishText;
  buttons: Array<{ [k: string]: string | number }> = registerFinishAction;

  // 発注の初期ステータス
  displayStatus = '';
  // 登録可能権限
  registAuthority = false;
  // コンポーネントで使用するタイトル等
  execActionMessage = authorityValidMessage;

  async created() {
    try {
      // ローディングをセット
      hexabaseState.setIsLoading(true);

      // 管理者権限判定
      if (!userState.isAdmin) {
        this.setError(this.basicModel.getDefaultRoleErrorMessage());
        return;
      }

      // 新規作成アクション一覧の取得
      const newAction = await this.basicModel.getNewActionList(this.mainDsId).then(data => {
        return data;
      });
      // 初期アクションに絞込み
      const initialAction = newAction.actions.filter(
        action => action.display_id === InformationDetailDefine.regist.registActionId
      );

      if (initialAction.length === 0) {
        // 登録権限なし
        this.registAuthority = false;
        this.execActionMessage = authorityInvalidMessage;
      } else {
        // 登録権限あり
        // アクションIDで定義されたインプットフィールド情報、DB定義に基づくフィールド情報を取得
        const [inputFields, fieldsData] = await Promise.all([
          this.basicModel.getFieldsByActionId(this.mainDsId, initialAction[0].action_id),
          this.basicModel.makeFieldsList(this.applicationId, this.mainDsId)
        ]);

        // 入力フォームのオプション定義追加
        // 更新不可フィールドのDisable化
        const data = this.basicModel
          .addOptionalFormField(
            fieldsData.filter(v => v.dataType !== 'status'),
            this.basicModel.deepCopy(informationRegisterOptionalForm),
            true
          )
          .map(field => this.basicModel.inputRestriction(field, inputFields));

        this.basicFieldCols = this.basicModel.getGridStatus(data);
        this.basicFieldData = (await this.modifyFields(
          data,
          inputFields,
          'information_regist'
        )) as Array<FieldChildrenProp>;

        this.registAuthority = true;
      }
    } catch (e) {
      this.setError(e as string | object);
    } finally {
      hexabaseState.setIsLoading(false);
    }
  }

  /**
   * 自動生成要素からの入力を取得
   * @param input {[k:string]: string}
   * @returns void
   */
  catchInput(input: { [k: string]: string }): void {
    const index = this.basicFieldData.findIndex(v => v.display_id === input.name);
    switch (this.basicFieldData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldData[index].props!, 'value', { i_id: input.value });
        break;
      default:
        this.$set(this.basicFieldData[index].props!, 'value', input.value);
    }

    // 入力値から登録データを生成
    const name = input.name;
    const value = input.value;
    this.registData.item[name] = value;
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta?.breadcrumbs;
    }
    return [];
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  async execAction(type: string) {
    switch (type) {
      case 'cancel': {
        // 前画面に戻る
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        break;
      }
      default: {
        try {
          // ローディングをセット
          hexabaseState.setIsLoading(true);
          // 押下された新規登録アクションを新規登録のpayloadに指定
          this.registData.action_id = type;
          // 登録APIを実行
          const result = await this.basicModel.registerLinkedItems(
            hexabaseState.applicationId,
            this.mainDsId,
            this.registData
          );
          // 登録API実行結果についてハンドリング（問題あればエラー内容がthrowされる）
          this.basicModel.apiErrorHandle('CREATEITEM', result);
          // 登録が成功した場合は、作成したアイテムの詳細画面への遷移ボタンを生成する
          this.buttons.map(v => {
            if (v.name === 'toEdit') {
              v.route = String(v.route).replace(':id', result.item_id);
            }
          });
        } catch (e) {
          this.registerText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          hexabaseState.setIsLoading(false);
          this.dialogStatus = true;
        }
        break;
      }
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  /**
   * フィールド整形用関数をまとめた関数
   * @param data {Array<FieldChildrenProp> | Array<FieldChildrenProp[]>} - テーブルが持つフィールドデータ
   * @param inputFields {GetInputFieldsActons} - テーブルアクションに対応するフィールドデータ
   * @param type {string} - テーブルアクションに対応するフィールドデータ
   * @returns modifyInputAllow(data, inputFields.action_field_settings)
   */
  async modifyFields(
    data: Array<FieldChildrenProp>,
    inputFields: GetInputFieldsActons,
    type: string
  ) {
    // フィールド情報にバリデーションルールを付与
    // ※必須ルールはアクション定義で自動判定されるため、その他の個別ルールを定義した情報を引渡す
    data = this.basicModel.addInputRules(
      data,
      inputFields.action_field_settings,
      type,
      informationRules.information_regist
    );
    return this.basicModel.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  /**
   * API実行結果から受け取ったエラーメッセージを共通のエラーダイアログに表示する
   * @param errorMessage {string | object } - API実行結果から受け取ったエラーメッセージ
   * @returns {void}
   */
  setError(errorMessage: string | object): void {
    if (typeof errorMessage === 'object') errorMessage = this.basicModel.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
